export const GET_FORM_PROPS = ({
  formObject = { _id: "" },
  changeHandlers = {
    handleChange: () => {
      console.log("Change");
    },
  },
}) => {
  const { _id } = formObject;
  const { handleChange } = changeHandlers;
  return [
    {
      type: "text",
      props: {
        "data-id": _id,
        label: "Id",
        value: _id,
        name: "_id",
        onChange: handleChange,
        classname: "w-96",
      },
    },
  ];
};
